import React, { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { API_URL } from '../../config/constants';
import './statistic.scss';
import summDataIconImg from '../../images/summ_dataIcon.png';
import statisticMenuIconImg from '../../images/statisticMenuIcon.png';

function Statistic() {
    const { pathname } = useLocation();
    const lastPathName = pathname.split('/')[3];
    const [sumDsArr, setSumDsArr] = useState([]);
    const [selSumDsId, setSelSumDsId] = useState(-1);

    async function getStructs() {
        try {
            const response = await axios.post(`${API_URL}/monitoring-manage/getStructs`, {}, { withCredentials: true });
            const sumDs = response?.data?.sumDs ?? [];
            setSumDsArr(Array.isArray(sumDs) ? [...sumDs] : []);
            setSelSumDsId(Array.isArray(sumDs) && sumDs.length > 0 ? sumDs[0].sumDsId : -1);
        } catch (err) {
            console.error('statistic getStructs:', err);
            setSumDsArr([]);
            setSelSumDsId(-1);
        }
    }

    useEffect(() => {
        getStructs();
    }, []);

    useEffect(() => {
        if (lastPathName === 'summ_data' && sumDsArr.length > 0) {
            setSelSumDsId(sumDsArr[0].sumDsId);
        } else if (lastPathName === 'operationRate' && sumDsArr.length > 0) {
            setSelSumDsId(sumDsArr[0].sumDsId);
        }
    }, [lastPathName, sumDsArr]);

    return (
        <div className='statisticPage'>
            <div className='statisticMenuArea'>
                <ul className='statisticMenuUl'>
                    <li className='statisticMenuLi'>
                        <Link
                            className={lastPathName === 'summ_data' ? 'statisticMenuBtn on' : 'statisticMenuBtn'}
                            to='/home/statistic/summ_data'
                        >
                            <div className="statisticMenuIconArea">
                                <img
                                    src={summDataIconImg}
                                    alt="품질 이력 분석"
                                    className="statisticMenuIcon"
                                />
                            </div>
                            <span>품질 이력 분석</span>
                        </Link>
                        {lastPathName === 'summ_data' ? (
                            <ul className='subMenuUl'>
                                <li>
                                    <Link className="subMenuLink current" to='/home/statistic/summ_data'>summ_data</Link>
                                </li>
                            </ul>
                        ) : null}
                    </li>
                    <li className='statisticMenuLi'>
                        <Link
                            className={lastPathName === 'operationRate' ? 'statisticMenuBtn on' : 'statisticMenuBtn'}
                            to='/home/statistic/operationRate'
                        >
                            <div className='statisticMenuIconArea'>
                                <img
                                    src={statisticMenuIconImg}
                                    alt="가동율 이력 분석"
                                    className="statisticMenuIcon"
                                />
                            </div>
                            <span>가동율 이력 분석</span>
                        </Link>
                        {lastPathName === 'operationRate' ? (
                            <ul className='subMenuUl'>
                                <li>
                                    <Link className={lastPathName === 'operationRate' ? 'subMenuLink current' : 'subMenuLink'} to='/home/statistic/operationRate'>summ_data</Link>
                                </li>
                            </ul>
                        ) : null}
                    </li>
                </ul>
            </div>
            <div className='statisticContentArea'>
                <Outlet context={{ selSumDsId, sumDsArr }} />
            </div>
        </div>
    );
}

export default Statistic;
